"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.root = exports.input = exports.background = void 0;

var _util = require("../../../util");

const background = ({
  cssProps,
  theme
}) => {
  const {
    variant = 'primary'
  } = cssProps;
  const themeVariant = theme.inputs[variant];
  return {
    background: (0, _util.color)(theme, themeVariant.background),
    borderRadius: themeVariant.borderRadius,
    bottom: 0,
    left: 0,
    // Usage of !important is because this element provides the visible styled
    // UI for this component, and must be specifically positioned.
    margin: '0 !important',
    pointerEvents: 'none',
    position: 'absolute',
    right: 0,
    top: 0,
    transition: 'box-shadow 0.2s ease',
    zIndex: -1
  };
};

exports.background = background;

const input = ({
  cssProps,
  theme
}) => {
  const {
    error = false,
    valid = false,
    variant = 'primary'
  } = cssProps;
  const isValid = valid && !error;
  const themeVariant = theme.inputs[variant];
  const boxShadow = error ? themeVariant.boxShadowError : themeVariant.boxShadow;
  const boxShadowActive = error ? themeVariant.boxShadowError : themeVariant.boxShadowActive;
  return { ...(0, _util.textStyle)(theme, themeVariant.textStyle),
    height: themeVariant.height,
    width: '100%',
    '&::placeholder': {
      color: (0, _util.color)(theme, themeVariant.colorPlaceholder),
      opacity: 1
    },
    '& + div': {
      background: (0, _util.color)(theme, themeVariant.background),
      boxShadow: (0, _util.boxShadow)(theme, isValid ? themeVariant.boxShadowValid : boxShadow)
    },
    '&:disabled': {
      color: (0, _util.color)(theme, themeVariant.colorDisabled),
      '& + div': {
        background: (0, _util.color)(theme, themeVariant.backgroundDisabled),
        boxShadow: (0, _util.boxShadow)(theme, themeVariant.boxShadowDisabled)
      }
    },
    '&:focus:not(:disabled)': {
      outline: 'none',
      '& + div': {
        boxShadow: (0, _util.boxShadow)(theme, boxShadowActive)
      }
    },
    '&:hover:not(:disabled) + div': {
      boxShadow: (0, _util.boxShadow)(theme, isValid ? themeVariant.boxShadowValid : boxShadow)
    },
    '&:-internal-autofill-selected': {
      boxShadow: (0, _util.boxShadow)(theme, [0, 0, 0, 30, themeVariant.background, true])
    }
  };
};

exports.input = input;

const root = ({
  cssProps,
  theme
}) => {
  const {
    variant = 'primary'
  } = cssProps;
  const themeVariant = theme.inputs[variant];
  return {
    color: (0, _util.color)(theme, themeVariant.colorPlaceholder),
    height: themeVariant.height,
    padding: (0, _util.spacing)(theme, themeVariant.padding),
    position: 'relative',
    zIndex: 0,
    '& > * + *': {
      marginLeft: (0, _util.spacing)(theme, themeVariant.marginInner)
    }
  };
};

exports.root = root;
//# sourceMappingURL=Input.style.js.map